export { TokenInfo } from '@tremaze/shared/auth/types';
